// extracted by mini-css-extract-plugin
module.exports = {"iconSize":"styles_iconSize__1E5Yg"};